var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationWebsite01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 178,
    viewBox: "0 0 220 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 57H78.1569V76.1871H37V57Z",
    fill: "#00A183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2746 72.221H88.2863V177H27.2746V72.221Z",
    fill: "#50BDA9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6946 90.4729H72.0842V163.06H45.6946V90.4729Z",
    fill: "#00A183"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.225 0H136.354V22H86.225V0Z",
    fill: "#1C5AB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1084 13.2036H158.483V177H64.1084V13.2036Z",
    fill: "#25509F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 32.3656H85.2977C83.5372 32.3656 82.1024 31.2044 82.1024 29.7734C82.1024 28.3424 83.5309 27.1812 85.2977 27.1812H89.4892C91.2498 27.1812 92.6845 28.3424 92.6845 29.7734C92.6845 31.2044 91.2561 32.3656 89.4892 32.3656Z",
    fill: "#E2F4F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.014 32.3656H110.823C109.062 32.3656 107.627 31.2044 107.627 29.7734C107.627 28.3424 109.056 27.1812 110.823 27.1812H115.014C116.775 27.1812 118.209 28.3424 118.209 29.7734C118.209 31.2044 116.781 32.3656 115.014 32.3656Z",
    fill: "#E2F4F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.533 32.3656H136.341C134.581 32.3656 133.146 31.2044 133.146 29.7734C133.146 28.3424 134.574 27.1812 136.341 27.1812H140.533C142.293 27.1812 143.728 28.3424 143.728 29.7734C143.728 31.2044 142.3 32.3656 140.533 32.3656Z",
    fill: "#E2F4F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 48.4961H85.2977C83.5372 48.4961 82.1024 47.3349 82.1024 45.9039C82.1024 44.4729 83.5309 43.3117 85.2977 43.3117H89.4892C91.2498 43.3117 92.6845 44.4729 92.6845 45.9039C92.6845 47.3349 91.2561 48.4961 89.4892 48.4961Z",
    fill: "#E2F4F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.014 48.4961H110.823C109.062 48.4961 107.627 47.3349 107.627 45.9039C107.627 44.4729 109.056 43.3117 110.823 43.3117H115.014C116.775 43.3117 118.209 44.4729 118.209 45.9039C118.209 47.3349 116.781 48.4961 115.014 48.4961Z",
    fill: "#E2F4F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.533 48.4961H136.341C134.581 48.4961 133.146 47.3349 133.146 45.9039C133.146 44.4729 134.574 43.3117 136.341 43.3117H140.533C142.293 43.3117 143.728 44.4729 143.728 45.9039C143.728 47.3349 142.3 48.4961 140.533 48.4961Z",
    fill: "#E2F4F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 64.6203H85.2977C83.5372 64.6203 82.1024 63.4591 82.1024 62.0281C82.1024 60.5971 83.5309 59.4359 85.2977 59.4359H89.4892C91.2498 59.4359 92.6845 60.5971 92.6845 62.0281C92.6845 63.4591 91.2561 64.6203 89.4892 64.6203Z",
    fill: "#E2F4F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.014 64.6203H110.823C109.062 64.6203 107.627 63.4591 107.627 62.0281C107.627 60.5971 109.056 59.4359 110.823 59.4359H115.014C116.775 59.4359 118.209 60.5971 118.209 62.0281C118.209 63.4591 116.781 64.6203 115.014 64.6203Z",
    fill: "#E2F4F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.533 64.6203H136.341C134.581 64.6203 133.146 63.4591 133.146 62.0281C133.146 60.5971 134.574 59.4359 136.341 59.4359H140.533C142.293 59.4359 143.728 60.5971 143.728 62.0281C143.728 63.4591 142.3 64.6203 140.533 64.6203Z",
    fill: "#E2F4F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 80.7445H85.2977C83.5372 80.7445 82.1024 79.5833 82.1024 78.1523C82.1024 76.7213 83.5309 75.5601 85.2977 75.5601H89.4892C91.2498 75.5601 92.6845 76.7213 92.6845 78.1523C92.6845 79.5833 91.2561 80.7445 89.4892 80.7445Z",
    fill: "#E2F4F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.199 80.7445H110.823C109.062 80.7445 107.627 79.5833 107.627 78.1523C107.627 76.7213 109.056 75.5601 110.823 75.5601H119.199C120.96 75.5601 122.395 76.7213 122.395 78.1523C122.395 79.5833 120.966 80.7445 119.199 80.7445Z",
    fill: "#E2F4F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 96.8686H85.2977C83.5372 96.8686 82.1024 95.7075 82.1024 94.2764C82.1024 92.8454 83.5309 91.6843 85.2977 91.6843H89.4892C91.2498 91.6843 92.6845 92.8454 92.6845 94.2764C92.6845 95.7075 91.2561 96.8686 89.4892 96.8686Z",
    fill: "#E2F4F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.199 96.8686H110.823C109.062 96.8686 107.627 95.7075 107.627 94.2764C107.627 92.8454 109.056 91.6843 110.823 91.6843H119.199C120.96 91.6843 122.395 92.8454 122.395 94.2764C122.395 95.7075 120.966 96.8686 119.199 96.8686Z",
    fill: "#E2F4F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 112.999H85.2977C83.5372 112.999 82.1024 111.838 82.1024 110.407C82.1024 108.976 83.5309 107.815 85.2977 107.815H89.4892C91.2498 107.815 92.6845 108.976 92.6845 110.407C92.6845 111.838 91.2561 112.999 89.4892 112.999Z",
    fill: "#E2F4F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.199 112.999H110.823C109.062 112.999 107.627 111.838 107.627 110.407C107.627 108.976 109.056 107.815 110.823 107.815H119.199C120.96 107.815 122.395 108.976 122.395 110.407C122.395 111.838 120.966 112.999 119.199 112.999Z",
    fill: "#E2F4F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 129.123H85.2977C83.5372 129.123 82.1024 127.962 82.1024 126.531C82.1024 125.1 83.5309 123.939 85.2977 123.939H89.4892C91.2498 123.939 92.6845 125.1 92.6845 126.531C92.6845 127.962 91.2561 129.123 89.4892 129.123Z",
    fill: "#E2F4F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.199 129.123H110.823C109.062 129.123 107.627 127.962 107.627 126.531C107.627 125.1 109.056 123.939 110.823 123.939H119.199C120.96 123.939 122.395 125.1 122.395 126.531C122.395 127.962 120.966 129.123 119.199 129.123Z",
    fill: "#E2F4F8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 145.254H85.2977C83.5372 145.254 82.1024 144.093 82.1024 142.662C82.1024 141.231 83.5309 140.069 85.2977 140.069H89.4892C91.2498 140.069 92.6845 141.231 92.6845 142.662C92.6845 144.093 91.2561 145.254 89.4892 145.254Z",
    fill: "#E2F4F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.199 145.254H110.823C109.062 145.254 107.627 144.093 107.627 142.662C107.627 141.231 109.056 140.069 110.823 140.069H119.199C120.96 140.069 122.395 141.231 122.395 142.662C122.395 144.093 120.966 145.254 119.199 145.254Z",
    fill: "#E2F4F8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4892 161.29H85.2977C83.5372 161.29 82.1024 160.129 82.1024 158.698C82.1024 157.267 83.5309 156.106 85.2977 156.106H89.4892C91.2498 156.106 92.6845 157.267 92.6845 158.698C92.6845 160.129 91.2561 161.29 89.4892 161.29Z",
    fill: "#E2F4F8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.199 161.29H110.823C109.062 161.29 107.627 160.129 107.627 158.698C107.627 157.267 109.056 156.106 110.823 156.106H119.199C120.96 156.106 122.395 157.267 122.395 158.698C122.395 160.129 120.966 161.29 119.199 161.29Z",
    fill: "#E2F4F8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.294 72.295H196.141V177.08H118.294V72.295Z",
    fill: "#F4C1AD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.031 84.8179H149.868V102.762H132.031V84.8179Z",
    fill: "#DCF9FE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.906 84.8179H180.75V102.762H162.906V84.8179Z",
    fill: "#DCF9FE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.031 115.572H149.868V133.517H132.031V115.572Z",
    fill: "#DCF9FE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.906 115.572H180.75V133.517H162.906V115.572Z",
    fill: "#DCF9FE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.031 146.327H149.868V164.271H132.031V146.327Z",
    fill: "#DCF9FE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.906 146.327H180.75V164.271H162.906V146.327Z",
    fill: "#DCF9FE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M205.022 31.3639L205.377 25.0892C205.431 23.974 206.95 23.5883 207.575 24.5368L210.99 29.717C211.195 30.0297 211.539 30.2278 211.927 30.2486L218.865 30.6134C219.985 30.6655 220.416 32.0518 219.511 32.6876L213.834 36.7004C213.554 36.8984 213.382 37.2007 213.349 37.5238L212.638 44.9554C212.531 46.0498 211.033 46.3937 210.43 45.4557L206.648 39.4833C206.465 39.1915 206.153 38.9934 205.808 38.9413L198.019 37.8156C196.867 37.6489 196.619 36.1688 197.653 35.6477L204.375 32.3228C204.752 32.1352 205 31.7703 205.022 31.3534V31.3639Z",
    fill: "#F4AD5E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M185.14 4.91587L185.989 3.48371C186.455 2.68916 187.749 2.92458 187.866 3.81723L188.078 5.38672C188.121 5.68099 188.312 5.94584 188.587 6.08317L190.476 7.03468C191.303 7.44667 191.112 8.59436 190.179 8.76111L188.004 9.14368C187.718 9.19272 187.474 9.34967 187.325 9.57529L186.063 11.547C185.575 12.3121 184.302 12.057 184.196 11.1644L183.963 9.12406C183.931 8.8494 183.772 8.60417 183.528 8.45703L181.448 7.1622C180.632 6.65211 181.003 5.49462 181.979 5.46519L184.27 5.40633C184.631 5.39653 184.949 5.21015 185.119 4.92568L185.14 4.91587Z",
    fill: "#F4AD5E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6986 18.9783L9.13875 18.6228C7.9728 18.5689 7.56962 17.0499 8.56123 16.4251L13.9769 13.01C14.3038 12.8054 14.5108 12.4606 14.5326 12.0728L14.914 5.13498C14.9685 4.01459 16.4178 3.58367 17.0825 4.4886L21.2777 10.166C21.4847 10.4461 21.8007 10.6184 22.1385 10.6508L29.9079 11.3618C31.052 11.4695 31.4116 12.9669 30.4309 13.5702L24.1871 17.3516C23.882 17.5347 23.675 17.8471 23.6205 18.1919L22.4436 25.9807C22.2693 27.1334 20.722 27.3812 20.1771 26.347L16.7011 19.6247C16.5049 19.2476 16.1235 18.9998 15.6877 18.9783H15.6986Z",
    fill: "#F4AD5E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12874 52.86L1.53746 52.0114C0.654619 51.5447 0.9162 50.2506 1.90803 50.1339L3.65191 49.9217C3.97888 49.8793 4.27316 49.6884 4.42575 49.4126L5.48298 47.5244C5.94074 46.697 7.21595 46.8879 7.40124 47.8214L7.82631 49.996C7.8808 50.2824 8.05519 50.5264 8.30587 50.6749L10.4966 51.9372C11.3468 52.4251 11.0634 53.6981 10.0715 53.8041L7.80451 54.0375C7.49933 54.0693 7.22685 54.2284 7.06336 54.4724L5.62467 56.5515C5.05791 57.3683 3.7718 56.997 3.7391 56.0211L3.6737 53.7299C3.6628 53.3692 3.45572 53.051 3.13964 52.8813L3.12874 52.86Z",
    fill: "#F4AD5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWebsite01);
export default __webpack_public_path__ + "static/media/illustration_website_01.56a2564032cb8066548394ac7e0f14bf.svg";
export { ForwardRef as ReactComponent };